var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('message-bubble',{attrs:{"is-mine":_vm.isMine,"message":_vm.message}},[_c('div',{staticClass:"custom-element-wrapper"},[_c('span',{staticClass:"text",attrs:{"title":_vm.$t('您可以自行解析自定义消息')}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }